export const blockIconsPlacesOtherHouses = (
	<span className='material-symbols-outlined'>other_houses</span>
);
